<template>
  <div
    v-if="!specialForCopyPaste && essay?.stickers?.length"
    class="sticker-container mb-3"
  >
    <div class="stickers">
      <div
        v-for="(sticker, index) in essay.stickers"
        :key="`sticker-${index}`"
        class="sticker"
      >
        <div class="code">{{ sticker.code }}</div>
        <div class="text">{{ sticker.text }}</div>
        <button class="remove" @click="handleRemoveSticker(index)">×</button>
      </div>
    </div>
  </div>
</template>

<script>
import stickerMixin from "@/components/essay/essay/v3/mixins/sticker_mixin";

export default {
  name: "EgStickers",
  mixins: [stickerMixin],
  inject: ["specialForCopyPaste"],
  props: {
    essay: {
      type: Object,
      required: true,
    },
  },
  methods: {
    async handleRemoveSticker(index) {
      await this.removeSticker(index);
      this.$emit("removeSticker", index);
    },
  },
};
</script>

<style scoped lang="scss">
.add-sticker-popover {
  width: 100%;
}
.sticker-container {
  display: flex;
  gap: 1rem;
  width: 100%;
  flex-direction: column;
}
.stickers {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}
.sticker {
  display: flex;
  padding: 4px 12px;
  align-items: center;
  gap: 8px;
  max-width: 100%;
  background-color: var(--purple-light);
  border-radius: 60px;
  .text {
    word-break: break-word;
  }
  .remove {
    display: flex;
    font-family: serif;
    background: transparent;
    border: none;
    outline: none;
    padding: 0;
    color: var(--grey-700);
    font-size: 24px;
    line-height: 21px;
  }
}
</style>
